/**
 * Réglages › Légal: Gately's own public documents, in one place a manager can
 * point a résident or an auditor at.
 */
import { createFileRoute, Link } from "@tanstack/react-router";
import { ExternalLink, FileText, ShieldCheck } from "lucide-react";

import { Card } from "@gately/ui/card";
import { SettingsSection } from "@gately/ui/settings";

export const Route = createFileRoute("/_dashboard/reglages/legal")({
  component: LegalTab,
});

function LegalTab() {
  return <LegalSection />;
}

function LegalSection() {
  const links = [
    {
      to: "/confidentialite" as const,
      label: "Politique de confidentialité",
      Icon: ShieldCheck,
    },
    {
      to: "/conditions" as const,
      label: "Conditions d'utilisation",
      Icon: FileText,
    },
  ];

  return (
    <SettingsSection
      title="Légal"
      hint="Documents publics de Gately."
      surface={false}
    >
      <Card className="divide-y p-0">
        {links.map(({ to, label, Icon }) => (
          <Link
            key={to}
            to={to}
            target="_blank"
            className="hover:bg-muted/50 flex items-center gap-3 p-4 text-sm transition-colors"
          >
            <Icon className="text-muted-foreground size-4" />
            <span className="font-medium">{label}</span>
            <ExternalLink className="text-muted-foreground ml-auto size-3.5" />
          </Link>
        ))}
      </Card>
    </SettingsSection>
  );
}
